// extracted by mini-css-extract-plugin
export var alertIcon = "_pw-0";